"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const tree_1 = require("@angular/cdk/tree");
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const treeview_1 = require("./treeview");
const main_service_1 = require("../main/main.service");
const material_1 = require("@angular/material");
const notification_dialog_1 = require("./dialogs/notification-dialog");
const global_1 = require("./global");
class ExplorerTreeComponent {
    constructor(database, fourD, mainService, dialog) {
        // console.log ( 'explorer-tree constructor' );
        this.database = database;
        this.fourD = fourD;
        this.mainService = mainService;
        this.dialog = dialog;
        this.searchCont = new forms_1.FormControl();
        this.subs = [];
        this.folderSelected = new core_1.EventEmitter();
        this.rootSelect = new core_1.EventEmitter();
        this.folderDelete = new core_1.EventEmitter();
        this.folderCount = new core_1.EventEmitter();
        this.getLevel = (node) => node.level;
        this.isExpandable = (node) => node.expandable;
        this.hasChild = (_, _nodeData) => _nodeData.expandable;
        this.counter = 0;
        // when search / filters change
        this.subs.push(this.searchCont.valueChanges.pipe(operators_1.debounceTime(1000)).subscribe(s => {
            // console.log ( 'explorer-tree searchChange -> refresh' );
            this.searchQ = s;
            this.refresh(s);
        }));
    }
    ngOnInit() {
        // console.log ( 'explorer-tree ngOnInit -> refresh' );
        // first, refresh
        this.refresh(null);
        // on search? (@alex)
        this.mainService.searchFilesFolder.subscribe(value => {
            // console.log ( 'explorer-tree searchFilesFolder -> refresh' );
            this.refresh(value);
        });
    }
    ngAfterViewInit() {
    }
    // what defines a change for this to kick in? (@alex)
    ngOnChanges(a) {
        if (a.baseQuery) {
            // console.log ( 'explorer-tree ngOnChanges -> refresh' );
            this.refresh(null);
        }
    }
    refresh(search) {
        // console.log ( 'explorer-tree **refresh**', this.subs );
        this.database.baseQuery = this.baseQuery;
        this.treeControl = null;
        // why the 300ms delay here? (@alex)
        setTimeout(() => {
            // this seems odd; adding new subscribes with every refresh? (@alex)
            this.subs.push(this.database.initialData(search).subscribe(s => {
                // console.log ( 'explorer-tree subscribe', s);
                this.treeControl = new tree_1.FlatTreeControl(this.getLevel, this.isExpandable);
                this.treeControl.expansionModel.changed.subscribe(s => {
                    //  s.added.forEach(a => this.dataSource.data.filter(d => d != a).forEach(d => this.treeControl.collapse(d)))
                });
                // console.log ( 'explorer-tree new DynamicDataSource', s);
                this.dataSource = new treeview_1.DynamicDataSource(this.treeControl, this.database);
                this.dataSource.data = s;
                // Emit event to notify count of folders
                this.folderCount.emit(s ? s.length : 0);
                setTimeout(() => {
                    var f = this.dataSource.data.find(d => d.item['root'] == 'myFiles');
                    this.treeControl.expand(f);
                    this.selectedRoot = f.item;
                }, 200);
                this.dataSource.filesChange.subscribe(s => {
                    !this.selectedFolder ? this.folderSelected.emit(this.selectedFolder) : '';
                });
            }));
        }, 200);
    }
    selectFolder(f, n) {
        // New requirement https://4dlink.atlassian.net/browse/DM4-287.
        // Showing pop-up for "Public Samples" folder.
        if (f.uid == 'public_global') {
            var publicFolderCheck = localStorage.getItem(global_1.PUBLIC_FOLDER_CHECK);
            if (publicFolderCheck != this.fourD.domainConfig.public_folder_check) {
                // Show popup
                let dialogRef = this.dialog.open(notification_dialog_1.NotificationDialog, {
                    width: '60%',
                    data: {
                        title: 'DIALOG.PUBLIC_FOLDER_TITLE',
                        text: this.fourD.domainConfig.public_folder_text,
                        checkboxText: 'DIALOG.PUBLIC_FOLDER_CHECKBOX',
                        posBtn: 'GENERIC.OK'
                    }
                });
                dialogRef.afterClosed().subscribe(dialogData => {
                    // If user selected to stop displaying thios check store it on the users local storage.
                    if (dialogData.checkboxValue) {
                        localStorage.setItem(global_1.PUBLIC_FOLDER_CHECK, this.fourD.domainConfig.public_folder_check);
                    }
                });
            }
        }
        /******************************************************* */
        this.currentNode = n;
        this.selectedFolder = f;
        if (f['root']) {
            this.selectedRoot = f;
            this.rootSelect.emit(f);
        }
        this.folderSelected.emit(this.selectedFolder);
        this.dataSource.data.filter(d => d.level == (n ? n.level : 0) && n != d && this.treeControl.isExpanded(d)).forEach(d => this.treeControl.collapse(d));
    }
    openFolder(f) {
        this.counter = 0;
        var v = this.dataSource.data.find(d => d.item == f);
        if (v)
            this.dataSource.toggleNode(v, true);
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
    getNodeState(node) {
        return {
            isOpen: this.treeControl.isExpanded(node),
            isForJob: node.item.forJobBatch ? true : false,
            isForProject: node.item.forProject ? true : false,
            isForScene: node.item.forScene ? true : false
        };
    }
    getIcon(node) {
        let state = this.getNodeState(node);
        if (this.counter++ == 1) {
            console.log('@@@', node);
        }
        if (state.isForProject) {
            if (state.isOpen) {
                return 'box-open';
            }
            else {
                return 'box';
            }
        }
        else if (state.isForJob) {
            if (state.isOpen) {
                return 'envelope-open';
            }
            else {
                return 'envelope';
            }
        }
        else if (state.isForScene) {
            if (state.isOpen) {
                return 'door-open';
            }
            else {
                return 'door-closed';
            }
        }
        if (state.isOpen) {
            return ['far', 'folder-open'];
        }
        else {
            return ['fas', 'folder'];
        }
    }
    getType(node) {
        let state = this.getNodeState(node);
        if (state.isForProject) {
            return 'project';
        }
        else if (state.isForJob) {
            return 'job';
        }
        else if (state.isForScene) {
            return 'scene';
        }
        return 'folder';
    }
    getCount(node) {
        let folders = node.item['folder_count'];
        let files = node.item['file_count'];
        let total = folders + files;
        if (total > 0) {
            return '(' + total + ')';
        }
        return '';
    }
}
exports.ExplorerTreeComponent = ExplorerTreeComponent;
